import React from 'react';
import { Box } from '@mui/material';
import { DossierStatus } from '../../../liste';

interface StatusWithChipProps {
    statut: string;
    statutId: number;
}

export const StatusWithChip: React.FunctionComponent<StatusWithChipProps> = function ({
    statut,
    statutId,
}) {
    return (
        <Box sx={{ display: 'flex', gap: '0 8px', alignItems: 'center' }}>
            <DossierStatus
                statutId={statutId}
                label={statut}
            />
        </Box>
    );
};
